<div [class.isFixed]="isFixed">
    <!--<app-social-header></app-social-header>-->
    <app-main-navbar></app-main-navbar>
    <!--<app-fixed-socials></app-fixed-socials>-->
    <app-contact-form></app-contact-form>
    <app-location></app-location>
    <app-subscribe></app-subscribe>
    <app-footer></app-footer>
</div>